import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AssetClass } from '../../Models/Domains/Investment/AssetClass';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';

declare var IS_RUNNING_IN_APP_POOL;

export class AssetClassesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(assetClassType: AssetClassType, hierarchyId: string): Promise<Array<AssetClass>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/AssetClasses/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { assetClassType: assetClassType, hierarchyId: hierarchyId }

    return AjaxWrapper.get<Array<AssetClass>, any>(url, data);
  }
}

